import { Component ,ElementRef} from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-customer-detail',
  templateUrl: './customer-detail.component.html',
  styleUrls: ['./customer-detail.component.scss']
})
export class CustomerDetailComponent {

  public loading:boolean = true;
  public CurrentDetail:any=[];
  public imgURL: any = "";
  public FollowList:any=[];
  public SubcriberList:any=[];
  public LikesList:any=[];
  public onBoardDetail:any=[];

  constructor(private el: ElementRef,public router: Router, public service: GlobalService) { 
    this.CurrentDetail= JSON.parse(localStorage.getItem('gra_EditData')||'{}');
    this.imgURL =this.CurrentDetail.profile_image;
    this.getDEtail();
    this.loading= false;
  }

  ngOnInit(): void {
  }


  getDEtail(){
    var detail={
      id:this.CurrentDetail._id
    }; 
    this.service.PostApis(detail,'/customer-detail').subscribe(((response:any)=>{
      if(response.success ==1) {
        var self=this,folows:any=[];
        if(response.data.record[0].gender.length !=0){
          response.data.record[0].gender=response.data.record[0].gender[0].name;
        } else {
          response.data.record[0].gender='--';
        }  
        if(response.data.record[0].follow_un_follow.length !=0){
          response.data.record[0].follow_un_follow.filter((el:any)=>{
            this.FollowList.push({fid:el._id , cid:el.creator[0]._id ,cname:el.creator[0].name,cimage:el.creator[0].profile_image, cusername:el.creator[0].user_handle  })
          })
        }
        if(response.data.record[0].subscribers.length !=0){
          response.data.record[0].subscribers.filter((el:any)=>{
            this.SubcriberList.push({id:el._id,image:el.profile_image,role:el.sub_roles[0].name,username:el.user_handle ,count:el.follower})
          })
        }
        if(response.data.record[0].user_onboardings.length !=0){
          response.data.record[0].user_onboardings.filter((el:any)=>{
            this.onBoardDetail.push({id:el._id,step:el.steps_questions[0].stepNumber,question:el.steps_questions[0].stepQues ,question_no:el.steps_questions[0].stepQuesNo ,answer:el.stepResp})
          })
        }
        if(response.data.record[0].like_un_likes.length !=0){
          response.data.record[0].like_un_likes.filter((el:any)=>{
            self.LikesList.push({post_category:el.posts[0].post_category,post_type:el.posts[0].post_type,image:el.posts[0].thumbnail,name:el.posts[0].name,like:el.posts[0].like,view:el.posts[0].view,is_free:el.posts[0].is_content_free})
          })
        }
        // this.onBoardDetail= response.data.record[0].user_onboardings ;
        // this.FollowList= response.data.record[0].follow_un_follow ;
        // this.SubcriberList= response.data.record[0].subscribers ;        
        this.CurrentDetail=response.data.record[0];
        this.loading=false;
      } else {
        this.loading=false;
      }
    }), (error) => { this.loading =false; });
  }

  
}
